import { Badge } from '@mantine/core';
import {
  CompulsoryInsurancePenaltyTicketState,
  COMPULSORY_INSURANCE_PENALTY_TICKET_STATE_POLICY,
} from '../model';

const STATE_BADGE_COLOR: Record<CompulsoryInsurancePenaltyTicketState, string> =
  {
    [CompulsoryInsurancePenaltyTicketState.PENDING]: 'yellow',
    [CompulsoryInsurancePenaltyTicketState.NO_FEE]: 'gray',
    [CompulsoryInsurancePenaltyTicketState.QUERY_FAILED]: 'red',
    [CompulsoryInsurancePenaltyTicketState.CHARGING]: 'blue',
    [CompulsoryInsurancePenaltyTicketState.CHARGE_FAILED]: 'orange',
    [CompulsoryInsurancePenaltyTicketState.CHARGE_SUCCESS]: 'green',
    [CompulsoryInsurancePenaltyTicketState.COMPLETED]: 'teal',
  };

export const CompulsoryInsurancePenaltyStateBadge = ({
  state,
}: {
  state: CompulsoryInsurancePenaltyTicketState;
}) => (
  <Badge color={STATE_BADGE_COLOR[state]} variant="light" size="lg">
    {COMPULSORY_INSURANCE_PENALTY_TICKET_STATE_POLICY[state].text}
  </Badge>
);
